import { computed } from 'vue'
import { SourceFilter, StatusFilter } from './FilterConfig'

export function useRidFilters(items, sourceFilter, statusFilter) {
  const sourceFilterItems = computed(() => {
    const values = [SourceFilter.ALL, SourceFilter.PLANNED, SourceFilter.UNPLANNED]

    return values.map((value) => ({
      label: SourceFilter.labels[value],
      color: SourceFilter.colors[value],
      value,
      count: items.value.filter(
        (item) =>
          SourceFilter.matches(item.source, value) &&
          StatusFilter.matches(item.status, statusFilter.value),
      ).length,
    }))
  })

  const statusFilterItems = computed(() => {
    const values = [
      StatusFilter.ALL,
      StatusFilter.REGISTERED,
      StatusFilter.APPLIED,
      StatusFilter.PENDING,
    ]

    return values.map((value) => ({
      label: StatusFilter.labels[value],
      color: StatusFilter.colors[value],
      value,
      count: items.value.filter(
        (item) =>
          SourceFilter.matches(item.source, sourceFilter.value) &&
          StatusFilter.matches(item.status, value),
      ).length,
    }))
  })

  const filteredItems = computed(() => {
    const statusPriority = [StatusFilter.PENDING, StatusFilter.APPLIED, StatusFilter.REGISTERED]

    return items.value
      .filter((item) => {
        const matchType = SourceFilter.matches(item.source, sourceFilter.value)
        const matchStatus = StatusFilter.matches(item.status, statusFilter.value)
        return matchType && matchStatus
      })
      .sort((a, b) => {
        const aIndex = statusPriority.indexOf(a.status)
        const bIndex = statusPriority.indexOf(b.status)

        const aPriority = aIndex === -1 ? Infinity : aIndex
        const bPriority = bIndex === -1 ? Infinity : bIndex

        if (aPriority !== bPriority) return aPriority - bPriority

        if (a.status === StatusFilter.REGISTERED && b.status === StatusFilter.REGISTERED) {
          return (b.info?.application?.date ?? 0) - (a.info?.application?.date ?? 0)
        }

        if (a.status === StatusFilter.APPLIED && b.status === StatusFilter.APPLIED) {
          return (a.info?.application?.date ?? 0) - (b.info?.application?.date ?? 0)
        }

        if (a.status === StatusFilter.PENDING && b.status === StatusFilter.PENDING) {
          return (a.plannedAt ?? 0) - (b.plannedAt ?? 0)
        }

        return 0
      })
  })

  return {
    sourceFilterItems,
    statusFilterItems,
    filteredItems,
  }
}
